import React, { useCallback, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@unite-us/ui';
export var ContinueEnrollmentModal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var insurance = props.insurance,
    goToEnrollmentWorkflow = props.goToEnrollmentWorkflow;
  var confirmDialogRef = useRef(null);
  var onOpen = function onOpen() {
    confirmDialogRef.current.openDialog();
  };
  useImperativeHandle(ref, function () {
    return {
      onOpen: onOpen
    };
  });
  var onContinueEnrollment = useCallback(function () {
    goToEnrollmentWorkflow(insurance.plan.id);
  }, [insurance]);
  return /*#__PURE__*/React.createElement(Dialog, {
    id: "continue-enrollment-dialog",
    className: "sub-dialog",
    ref: confirmDialogRef,
    title: "Enrollment Requirements",
    modal: true,
    onRequestClose: function onRequestClose() {
      return confirmDialogRef.current.closeDialog();
    },
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: "action-item border-dark-pale-blue normal-case",
      label: "Back",
      onClick: function onClick() {
        return confirmDialogRef.current.closeDialog();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      className: "action-item",
      label: "Continue with enrollment",
      primary: true,
      onClick: onContinueEnrollment
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "pb-4"
  }, /*#__PURE__*/React.createElement("b", null, "This social care coverage plan has prerequisites for enrollment.")), /*#__PURE__*/React.createElement("p", {
    className: "pb-4"
  }, "Choose \"Continue with enrollment\" to provide the required documentation in order to proceed with the enrollment request."))));
});
ContinueEnrollmentModal.propTypes = {
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  insurance: PropTypes.object.isRequired
};
//# sourceMappingURL=ContinueEnrollmentModal.js.map